<template>
  <div class="row">
      <iframe style="width: 100%; height: 88vh;" src="http://35.234.202.1"></iframe>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>